
<template>
  <div id="app">
     <nav-header></nav-header>
    <router-view :key="$route.fullPath"/>
  </div>
</template>

<script>
import navHeader from '@/components/header.vue'
export default {
  name: 'App',
  components: {
    navHeader
  }
}
</script>

<style>
		::-webkit-scrollbar {
			display: none;
		}
    body {
        overflow-y: scroll;
        width: 100%;
        margin: 0px;
    }
</style>



// WEBPACK FOOTER //
// src/App.vue